export const ALL_BADGES = [
	"incomplete_planning",
	"full_planning",
	"planning_exceeded",
	"planning_overloaded",
	"var_var_under_minimum",
	"unknown",
]
